module.exports = __webpack_public_path__ + "static/media/gatsby-icon.4a977354.png";